module.exports = __webpack_public_path__ + "img/scope1.6c4ffd1d.png";